import { formatDateTimeDisplay } from 'utils/formattedString';
import StatusLabel from '../components/StatusLabel';
import { Link } from 'react-router-dom';
import { Tag, Typography } from 'antd';
import {
  APPROVED_SUB_STATUS,
  FAILED_QC_REASON,
  RETURN_CHANNEL,
  RETURN_METHOD,
  RETURN_REASON,
  RETURN_STATUS,
} from 'constants/ordersReturn';
// import { useTranslation } from "react-i18next";
import i18n from 'i18n';

export const getColumns = (status) => {
  // const { t } = useTranslation();
  switch (status) {
    case RETURN_STATUS['AWAITING_APPROVAL'].value:
      return [
        {
          name: 'returnNumber',
          title: 'Return request No',
          render: (d, record) => (
            <Link to={`/orders-return/${record?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                {d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'orderNumber',
          title: 'Order No',
          render: (id, record) => (
            <Link to={`/order-management/${record?.orderId}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                {id}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'customer.name',
          title: 'Customer name',
          render: (d, record) => (
            <div>
              <p className="text-text-title-gray">{`${record?.order?.customer?.firstName || ''} ${record?.order?.customer?.lastName || ''}`}</p>
              <p className="text-text-secondary">
                {record?.order?.customer?.email}
              </p>
            </div>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'totalItem',
          title: 'Item Returned',
          render: (d, record) => <div>{d || record?.items?.length || 0}</div>,
          isDefault: true,
          width: 140,
          ellipsis: true,
        },
        {
          name: 'returnType',
          title: 'Return Type',
          render: (d) => (
            <div>
              {
                Object.values(RETURN_CHANNEL)?.find((item) => item.value === d)
                  ?.label
              }
            </div>
          ),
          isDefault: true,
          width: 120,
          ellipsis: true,
        },
        {
          name: 'returnMethod',
          title: 'Return Method',
          render: (d) => <div>{i18n.t(RETURN_METHOD[d]?.text)}</div>,
          width: 140,
          ellipsis: true,
        },
        {
          name: 'order.channel',
          title: 'Channel',
          render: (d, record) => (
            <div>{record?.order?.channelDisplay || ''}</div>
          ),
          isDefault: true,
          width: 100,
          ellipsis: true,
        },
        {
          name: 'order.location.name',
          title: 'From Warehouse',
          render: (d, record) => <div>{record?.order?.location?.name}</div>,
          isDefault: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'returnWarehouse.name',
          title: 'To Warehouse',
          render: (d, record) => {
            if (record?.returnType === RETURN_CHANNEL['OFFLINE'].value) {
              return <div>{record?.returnWarehouse?.name}</div>;
            }
            return <div>{record?.order?.location?.name || ''}</div>;
          },
          isDefault: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'createdAt',
          title: 'Created time',
          render: (d) => <div>{formatDateTimeDisplay(d)}</div>,
          isDefault: true,
          sorter: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'reason',
          title: 'Return Reason ',
          render: (d) => <div>{i18n.t(RETURN_REASON[d]?.text)}</div>,
          width: 180,
          ellipsis: true,
        },
        {
          name: 'paymentType',
          title: 'Payment Method',
          render: (d, record) => (
            <div>
              {record?.refundPaymentMethod?.name || record?.order?.paymentType}
            </div>
          ),
          width: 160,
          ellipsis: true,
        },
      ];
    case RETURN_STATUS['APPROVED'].value:
      return [
        {
          name: 'returnNumber',
          title: 'Return request No',
          render: (d, record) => (
            <Link to={`/orders-return/${record?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                {d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'orderNumber',
          title: 'Order No',
          render: (id, record) => (
            <Link to={`/order-management/${record?.orderId}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                {id}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'customer.name',
          title: 'Customer name',
          render: (d, record) => (
            <div>
              <p className="text-text-title-gray">{`${record?.order?.customer?.firstName || ''} ${record?.order?.customer?.lastName || ''}`}</p>
              <p className="text-text-secondary">
                {record?.order?.customer?.email}
              </p>
            </div>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'totalItem',
          title: 'Item Returned',
          render: (d, record) => <div>{d || record?.items?.length || 0}</div>,
          isDefault: true,
          width: 140,
          ellipsis: true,
        },
        {
          name: 'returnType',
          title: 'Return Type',
          render: (d) => (
            <div>
              {
                Object.values(RETURN_CHANNEL)?.find((item) => item.value === d)
                  ?.label
              }
            </div>
          ),
          isDefault: true,
          width: 120,
          ellipsis: true,
        },
        {
          name: 'returnMethod',
          title: 'Return Method',
          render: (d) => <div>{i18n.t(RETURN_METHOD[d]?.text)}</div>,
          width: 140,
          ellipsis: true,
        },
        {
          name: 'approvedTime',
          title: 'Approved time',
          render: (d) => <div>{formatDateTimeDisplay(d)}</div>,
          isDefault: true,
          sorter: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'shippingStatus',
          title: 'Shipping Status',
          render: (d) => (
            <StatusLabel status={d} dataFull={APPROVED_SUB_STATUS} />
          ),
          isDefault: true,
          width: 170,
          ellipsis: true,
        },
        {
          name: 'order.channel',
          title: 'Channel',
          render: (d, record) => (
            <div>{record?.order?.channelDisplay || ''}</div>
          ),
          isDefault: true,
          width: 100,
          ellipsis: true,
        },
        {
          name: 'order.location.name',
          title: 'From Warehouse',
          render: (d, record) => <div>{record?.order?.location?.name}</div>,
          isDefault: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'returnWarehouse.name',
          title: 'To Warehouse',
          render: (d, record) => {
            if (record?.returnType === RETURN_CHANNEL['OFFLINE'].value) {
              return <div>{record?.returnWarehouse?.name}</div>;
            }
            return <div>{record?.order?.location?.name || ''}</div>;
          },
          isDefault: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'reason',
          title: 'Return Reason ',
          render: (d) => <div>{i18n.t(RETURN_REASON[d]?.text)}</div>,
          width: 180,
          ellipsis: true,
        },
        {
          name: 'deliveryCode',
          title: 'Shipping no',
          isDefault: true,
          width: 140,
          ellipsis: true,
        },
        {
          name: 'paymentType',
          title: 'Payment Method',
          render: (d, record) => (
            <div>
              {record?.refundPaymentMethod?.name || record?.order?.paymentType}
            </div>
          ),
          width: 160,
          ellipsis: true,
        },
        {
          name: 'physicalGoodsReceived',
          title: 'Marked as Received',
          render: (d) => (
            <>{d ? <Tag color="blue">Yes</Tag> : <Tag color="red">No</Tag>}</>
          ),
          width: 160,
          ellipsis: true,
        },
      ];
    case RETURN_STATUS['PASS_QC'].value:
      return [
        {
          name: 'returnNumber',
          title: 'Return request No',
          render: (d, record) => (
            <Link to={`/orders-return/${record?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                {d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'orderNumber',
          title: 'Order No',
          render: (id, record) => (
            <Link to={`/order-management/${record?.orderId}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                {id}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'customer.name',
          title: 'Customer name',
          render: (d, record) => (
            <div>
              <p className="text-text-title-gray">{`${record?.order?.customer?.firstName || ''} ${record?.order?.customer?.lastName || ''}`}</p>
              <p className="text-text-secondary">
                {record?.order?.customer?.email}
              </p>
            </div>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'totalItem',
          title: 'Item Returned',
          render: (d, record) => <div>{d || record?.items?.length || 0}</div>,
          isDefault: true,
          width: 140,
          ellipsis: true,
        },
        {
          name: 'returnType',
          title: 'Return Type',
          render: (d) => (
            <div>
              {
                Object.values(RETURN_CHANNEL)?.find((item) => item.value === d)
                  ?.label
              }
            </div>
          ),
          isDefault: true,
          width: 120,
          ellipsis: true,
        },
        {
          name: 'returnMethod',
          title: 'Return Method',
          render: (d) => <div>{i18n.t(RETURN_METHOD[d]?.text)}</div>,
          width: 140,
          ellipsis: true,
        },
        {
          name: 'order.channel',
          title: 'Channel',
          render: (d, record) => (
            <div>{record?.order?.channelDisplay || ''}</div>
          ),
          isDefault: true,
          width: 100,
          ellipsis: true,
        },
        {
          name: 'order.location.name',
          title: 'From Warehouse',
          render: (d, record) => <div>{record?.order?.location?.name}</div>,
          isDefault: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'returnWarehouse.name',
          title: 'To Warehouse',
          render: (d, record) => {
            if (record?.returnType === RETURN_CHANNEL['OFFLINE'].value) {
              return <div>{record?.returnWarehouse?.name}</div>;
            }
            return <div>{record?.order?.location?.name || ''}</div>;
          },
          isDefault: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'reason',
          title: 'Return Reason ',
          render: (d) => <div>{i18n.t(RETURN_REASON[d]?.text)}</div>,
          width: 180,
          ellipsis: true,
        },
        {
          name: 'passQCTime',
          title: 'Passed QC time',
          render: (d) => <div>{formatDateTimeDisplay(d)}</div>,
          isDefault: true,
          sorter: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'passQCNote',
          title: 'Note Pass QC',
          isDefault: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'paymentType',
          title: 'Payment Method',
          render: (d, record) => (
            <div>
              {record?.refundPaymentMethod?.name || record?.order?.paymentType}
            </div>
          ),
          width: 160,
          ellipsis: true,
        },
      ];
    case RETURN_STATUS['FAILED_QC'].value:
      return [
        {
          name: 'returnNumber',
          title: 'Return request No',
          render: (d, record) => (
            <Link to={`/orders-return/${record?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                {d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'orderNumber',
          title: 'Order No',
          render: (id, record) => (
            <Link to={`/order-management/${record?.orderId}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                {id}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'customer.name',
          title: 'Customer name',
          render: (d, record) => (
            <div>
              <p className="text-text-title-gray">{`${record?.order?.customer?.firstName || ''} ${record?.order?.customer?.lastName || ''}`}</p>
              <p className="text-text-secondary">
                {record?.order?.customer?.email}
              </p>
            </div>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'totalItem',
          title: 'Item Returned',
          render: (d, record) => <div>{d || record?.items?.length || 0}</div>,
          isDefault: true,
          width: 140,
          ellipsis: true,
        },
        {
          name: 'returnType',
          title: 'Return Type',
          render: (d) => (
            <div>
              {
                Object.values(RETURN_CHANNEL)?.find((item) => item.value === d)
                  ?.label
              }
            </div>
          ),
          isDefault: true,
          width: 120,
          ellipsis: true,
        },
        {
          name: 'returnMethod',
          title: 'Return Method',
          render: (d) => <div>{i18n.t(RETURN_METHOD[d]?.text)}</div>,
          width: 140,
          ellipsis: true,
        },
        {
          name: 'order.channel',
          title: 'Channel',
          render: (d, record) => (
            <div>{record?.order?.channelDisplay || ''}</div>
          ),
          isDefault: true,
          width: 100,
          ellipsis: true,
        },
        {
          name: 'order.location.name',
          title: 'From Warehouse',
          render: (d, record) => <div>{record?.order?.location?.name}</div>,
          isDefault: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'returnWarehouse.name',
          title: 'To Warehouse',
          render: (d, record) => {
            if (record?.returnType === RETURN_CHANNEL['OFFLINE'].value) {
              return <div>{record?.returnWarehouse?.name}</div>;
            }
            return <div>{record?.order?.location?.name || ''}</div>;
          },
          isDefault: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'reason',
          title: 'Return Reason ',
          render: (d) => <div>{i18n.t(RETURN_REASON[d]?.text)}</div>,
          width: 180,
          ellipsis: true,
        },
        {
          name: 'failedQCTime',
          title: 'Failed QC time',
          render: (d) => <div>{formatDateTimeDisplay(d)}</div>,
          isDefault: true,
          sorter: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'failedQCReason',
          title: 'Failed QC reason',
          render: (d) => <div>{i18n.t(FAILED_QC_REASON[d]?.label)}</div>,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'failedQCNote',
          title: 'Note',
          isDefault: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'paymentType',
          title: 'Payment Method',
          render: (d, record) => (
            <div>
              {record?.refundPaymentMethod?.name || record?.order?.paymentType}
            </div>
          ),
          width: 160,
          ellipsis: true,
        },
      ];
    case RETURN_STATUS['COMPLETED'].value:
      return [
        {
          name: 'returnNumber',
          title: 'Return request No',
          render: (d, record) => (
            <Link to={`/orders-return/${record?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                {d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'orderNumber',
          title: 'Order No',
          render: (id, record) => (
            <Link to={`/order-management/${record?.orderId}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                {id}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'customer.name',
          title: 'Customer name',
          render: (d, record) => (
            <div>
              <p className="text-text-title-gray">{`${record?.order?.customer?.firstName || ''} ${record?.order?.customer?.lastName || ''}`}</p>
              <p className="text-text-secondary">
                {record?.order?.customer?.email}
              </p>
            </div>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'totalItem',
          title: 'Item Returned',
          render: (d, record) => <div>{d || record?.items?.length || 0}</div>,
          isDefault: true,
          width: 140,
          ellipsis: true,
        },
        {
          name: 'returnType',
          title: 'Return Type',
          render: (d) => (
            <div>
              {
                Object.values(RETURN_CHANNEL)?.find((item) => item.value === d)
                  ?.label
              }
            </div>
          ),
          isDefault: true,
          width: 120,
          ellipsis: true,
        },
        {
          name: 'returnMethod',
          title: 'Return Method',
          render: (d) => <div>{i18n.t(RETURN_METHOD[d]?.text)}</div>,
          width: 140,
          ellipsis: true,
        },
        {
          name: 'order.channel',
          title: 'Channel',
          render: (d, record) => (
            <div>{record?.order?.channelDisplay || ''}</div>
          ),
          isDefault: true,
          width: 100,
          ellipsis: true,
        },
        {
          name: 'order.location.name',
          title: 'From Warehouse',
          render: (d, record) => <div>{record?.order?.location?.name}</div>,
          isDefault: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'returnWarehouse.name',
          title: 'To Warehouse',
          render: (d, record) => {
            if (record?.returnType === RETURN_CHANNEL['OFFLINE'].value) {
              return <div>{record?.returnWarehouse?.name}</div>;
            }
            return <div>{record?.order?.location?.name || ''}</div>;
          },
          isDefault: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'reason',
          title: 'Return Reason ',
          render: (d) => <div>{i18n.t(RETURN_REASON[d]?.text)}</div>,
          width: 180,
          ellipsis: true,
        },
        {
          name: 'completedTime',
          title: 'Completed time',
          render: (d) => <div>{formatDateTimeDisplay(d)}</div>,
          isDefault: true,
          sorter: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'sorId',
          title: 'SOR',
          isDefault: true,
          width: 100,
          ellipsis: true,
        },
        {
          name: 'paymentType',
          title: 'Payment Method',
          render: (d, record) => (
            <div>
              {record?.refundPaymentMethod?.name || record?.order?.paymentType}
            </div>
          ),
          width: 160,
          ellipsis: true,
        },
      ];
    case RETURN_STATUS['CANCELLED'].value:
      return [
        {
          name: 'returnNumber',
          title: 'Return request No',
          render: (d, record) => (
            <Link to={`/orders-return/${record?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                {d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'orderNumber',
          title: 'Order No',
          render: (id, record) => (
            <Link to={`/order-management/${record?.orderId}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                {id}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'customer.name',
          title: 'Customer name',
          render: (d, record) => (
            <div>
              <p className="text-text-title-gray">{`${record?.order?.customer?.firstName || ''} ${record?.order?.customer?.lastName || ''}`}</p>
              <p className="text-text-secondary">
                {record?.order?.customer?.email}
              </p>
            </div>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'totalItem',
          title: 'Item Returned',
          render: (d, record) => <div>{d || record?.items?.length || 0}</div>,
          isDefault: true,
          width: 140,
          ellipsis: true,
        },
        {
          name: 'returnType',
          title: 'Return Type',
          render: (d) => (
            <div>
              {
                Object.values(RETURN_CHANNEL)?.find((item) => item.value === d)
                  ?.label
              }
            </div>
          ),
          isDefault: true,
          width: 120,
          ellipsis: true,
        },
        {
          name: 'returnMethod',
          title: 'Return Method',
          render: (d) => <div>{i18n.t(RETURN_METHOD[d]?.text)}</div>,
          width: 140,
          ellipsis: true,
        },
        {
          name: 'order.channel',
          title: 'Channel',
          render: (d, record) => (
            <div>{record?.order?.channelDisplay || ''}</div>
          ),
          isDefault: true,
          width: 100,
          ellipsis: true,
        },
        {
          name: 'order.location.name',
          title: 'From Warehouse',
          render: (d, record) => <div>{record?.order?.location?.name}</div>,
          isDefault: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'returnWarehouse.name',
          title: 'To Warehouse',
          render: (d, record) => {
            if (record?.returnType === RETURN_CHANNEL['OFFLINE'].value) {
              return <div>{record?.returnWarehouse?.name}</div>;
            }
            return <div>{record?.order?.location?.name || ''}</div>;
          },
          isDefault: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'reason',
          title: 'Return Reason ',
          render: (d) => <div>{i18n.t(RETURN_REASON[d]?.text)}</div>,
          width: 180,
          ellipsis: true,
        },
        {
          name: 'cancelledTime',
          title: 'Cancelled time',
          render: (d) => <div>{formatDateTimeDisplay(d)}</div>,
          isDefault: true,
          sorter: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'paymentType',
          title: 'Payment Method',
          render: (d, record) => (
            <div>
              {record?.refundPaymentMethod?.name || record?.order?.paymentType}
            </div>
          ),
          width: 160,
          ellipsis: true,
        },
        // {
        //    name: 'cancelNote',
        //    title: 'Note',
        //    isDefault: true,
        // },
      ];
    case RETURN_STATUS['WAITING_FOR_REFUND'].value:
      return [
        {
          name: 'returnNumber',
          title: 'Return request No',
          render: (d, record) => (
            <Link to={`/orders-return/${record?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                {d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'orderNumber',
          title: 'Order No',
          render: (id, record) => (
            <Link to={`/order-management/${record?.orderId}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                {id}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'customer.name',
          title: 'Customer name',
          render: (d, record) => (
            <div>
              <p className="text-text-title-gray">{`${record?.order?.customer?.firstName || ''} ${record?.order?.customer?.lastName || ''}`}</p>
              <p className="text-text-secondary">
                {record?.order?.customer?.email}
              </p>
            </div>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'totalItem',
          title: 'Item Returned',
          render: (d, record) => <div>{d || record?.items?.length || 0}</div>,
          isDefault: true,
          width: 140,
          ellipsis: true,
        },
        {
          name: 'returnType',
          title: 'Return Type',
          render: (d) => (
            <div>
              {
                Object.values(RETURN_CHANNEL)?.find((item) => item.value === d)
                  ?.label
              }
            </div>
          ),
          isDefault: true,
          width: 120,
          ellipsis: true,
        },
        {
          name: 'returnMethod',
          title: 'Return Method',
          render: (d) => <div>{i18n.t(RETURN_METHOD[d]?.text)}</div>,
          width: 140,
          ellipsis: true,
        },
        {
          name: 'order.channel',
          title: 'Channel',
          render: (d, record) => (
            <div>{record?.order?.channelDisplay || ''}</div>
          ),
          isDefault: true,
          width: 100,
          ellipsis: true,
        },
        {
          name: 'order.location.name',
          title: 'From Warehouse',
          render: (d, record) => <div>{record?.order?.location?.name}</div>,
          isDefault: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'returnWarehouse.name',
          title: 'To Warehouse',
          render: (d, record) => {
            if (record?.returnType === RETURN_CHANNEL['OFFLINE'].value) {
              return <div>{record?.returnWarehouse?.name}</div>;
            }
            return <div>{record?.order?.location?.name || ''}</div>;
          },
          isDefault: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'reason',
          title: 'Return Reason ',
          render: (d) => <div>{i18n.t(RETURN_REASON[d]?.text)}</div>,
          width: 180,
          ellipsis: true,
        },
        {
          name: 'requestRefundTime',
          title: 'Request Refund Time',
          render: (d) => <div>{formatDateTimeDisplay(d)}</div>,
          isDefault: true,
          sorter: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'paymentType',
          title: 'Payment Method',
          render: (d, record) => (
            <div>
              {record?.refundPaymentMethod?.name || record?.order?.paymentType}
            </div>
          ),
          width: 160,
          ellipsis: true,
        },
      ];
    default:
      return [
        {
          name: 'returnNumber',
          title: 'Return request No',
          render: (d, record) => (
            <Link to={`/orders-return/${record?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                {d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'orderNumber',
          title: 'Order No',
          render: (id, record) => (
            <Link to={`/order-management/${record?.orderId}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                {id}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'customer.name',
          title: 'Customer name',
          render: (d, record) => (
            <div>
              <p className="text-text-title-gray">{`${record?.order?.customer?.firstName || ''} ${record?.order?.customer?.lastName || ''}`}</p>
              <p className="text-text-secondary">
                {record?.order?.customer?.email}
              </p>
            </div>
          ),
          isDefault: true,
          width: 200,
          ellipsis: true,
        },
        {
          name: 'order.address.telephone',
          title: 'Shipping Phone',
          render: (d, record) => <div>{record?.order?.address?.telephone}</div>,
          width: 140,
          ellipsis: true,
        },
        {
          name: 'totalItem',
          title: 'Item Returned',
          render: (d, record) => <div>{d || record?.items?.length || 0}</div>,
          isDefault: true,
          width: 140,
          ellipsis: true,
        },
        {
          name: 'returnType',
          title: 'Return Type',
          render: (d) => (
            <div>
              {
                Object.values(RETURN_CHANNEL)?.find((item) => item.value === d)
                  ?.label
              }
            </div>
          ),
          isDefault: true,
          width: 120,
          ellipsis: true,
        },
        {
          name: 'returnMethod',
          title: 'Return Method',
          render: (d) => <div>{i18n.t(RETURN_METHOD[d]?.text)}</div>,
          width: 140,
          ellipsis: true,
        },
        {
          name: 'status',
          title: 'Return Status',
          render: (d) => <StatusLabel status={d} dataFull={RETURN_STATUS} />,
          isDefault: true,
          width: 140,
          ellipsis: true,
        },
        {
          name: 'order.channel',
          title: 'Channel',
          render: (d, record) => (
            <div>{record?.order?.channelDisplay || ''}</div>
          ),
          isDefault: true,
          width: 100,
          ellipsis: true,
        },
        {
          name: 'order.location.name',
          title: 'From Warehouse',
          render: (d, record) => <div>{record?.order?.location?.name}</div>,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'returnWarehouse.name',
          title: 'To Warehouse',
          render: (d, record) => {
            if (record?.returnType === RETURN_CHANNEL['OFFLINE'].value) {
              return <div>{record?.returnWarehouse?.name}</div>;
            }
            return <div>{record?.order?.location?.name || ''}</div>;
          },
          width: 160,
          ellipsis: true,
        },
        {
          name: 'deliveryCode',
          title: 'Shipping no',
          width: 140,
          ellipsis: true,
        },
        // {
        //   name: 'shippingCarrier.name',
        //   title: 'D.Partner',
        //   render: (d, record) => (
        //     <div>
        //       {record?.shippingCarrier?.name || record?.shippingCarrier?.code}
        //     </div>
        //   ),
        //   width: 160,
        //   ellipsis: true,
        // },
        {
          name: 'createdAt',
          title: 'Created time',
          render: (d) => <div>{formatDateTimeDisplay(d)}</div>,
          isDefault: true,
          sorter: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'reason',
          title: 'Return Reason ',
          render: (d) => <div>{i18n.t(RETURN_REASON[d]?.text)}</div>,
          width: 180,
          ellipsis: true,
        },
        {
          name: 'approvedTime',
          title: 'Approved time',
          render: (d) => <div>{formatDateTimeDisplay(d)}</div>,
          sorter: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'passQCTime',
          title: 'Passed QC time',
          render: (d) => <div>{formatDateTimeDisplay(d)}</div>,
          sorter: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'completedTime',
          title: 'Completed time',
          render: (d) => <div>{formatDateTimeDisplay(d)}</div>,
          sorter: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'cancelledTime',
          title: 'Cancelled time',
          render: (d) => <div>{formatDateTimeDisplay(d)}</div>,
          sorter: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'failedQCTime',
          title: 'Failed QC time',
          render: (d) => <div>{formatDateTimeDisplay(d)}</div>,
          sorter: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'failedQCReason',
          title: 'Failed QC reason',
          render: (d) => <div>{i18n.t(FAILED_QC_REASON[d]?.label)}</div>,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'exchangeId',
          title: 'Is Exchange',
          render: (d) => (
            <Tag
              color={d ? 'blue' : 'red'}
              style={{ borderRadius: 5, padding: '5px 10px', border: 'none' }}
            >
              {d ? 'Yes' : 'No'}
            </Tag>
          ),
          isDefault: true,
          width: 160,
          ellipsis: true,
        },
        {
          name: 'sorId',
          title: 'SOR',
          width: 180,
          ellipsis: true,
        },
        {
          name: 'soId',
          title: 'SO',
          width: 180,
          render: (d, record) => record?.order?.saleOrderId,
          ellipsis: true,
        },
        {
          name: 'paymentType',
          title: 'Payment Method',
          render: (d, record) => (
            <div>
              {record?.refundPaymentMethod?.name || record?.order?.paymentType}
            </div>
          ),
          width: 160,
          ellipsis: true,
        },
      ];
  }
};
